module.exports = __webpack_public_path__ + "img/tb.8771f986.png";